import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89f95f7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "root",
  class: "nge-gemfx",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5 9 L9 4 L15 4 L19 9 L12 20 Z",
  fill: "currentColor"
}, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "nge-gemfx-ring"
}
const _hoisted_5 = {
  key: 2,
  class: "nge-gemfx-ring nge-gemfx-ring--blue"
}
const _hoisted_6 = {
  class: "nge-gemfx-gem",
  viewBox: "0 0 24 24",
  width: "30",
  height: "30"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5 9 L9 4 L15 4 L19 9 L12 20 Z",
  fill: "currentColor"
}, null, -1 /* HOISTED */))
const _hoisted_8 = {
  key: 0,
  d: "M10 5 L12.5 10 L10.5 13 L13 18",
  fill: "none",
  stroke: "#0b1020",
  "stroke-width": "1.6",
  "stroke-linejoin": "round"
}
const _hoisted_9 = { class: "nge-gemfx-word" }
const _hoisted_10 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.pending && !$setup.shown)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "nge-gemfx-spot",
          style: _normalizeStyle({ left: $setup.pending.x + 'px', top: $setup.pending.y + 'px' })
        }, [
          (!$setup.pixelSpin)
            ? (_openBlock(), _createElementBlock("svg", {
                key: 0,
                class: _normalizeClass(["nge-gemfx-spin", `nge-gemfx-spin--${$setup.pending.gem}`]),
                viewBox: "0 0 24 24",
                width: "26",
                height: "26"
              }, _hoisted_3, 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ], 4 /* STYLE */))
      : _createCommentVNode("v-if", true),
    ($setup.shown)
      ? (_openBlock(), _createElementBlock("div", {
          key: $setup.shown.key,
          class: _normalizeClass(["nge-gemfx-spot", [`nge-gemfx--${$setup.shown.result}`, { 'nge-gemfx--ext': $setup.shown.result === 'hit' && $setup.shown.kind === 'merge' }]]),
          style: _normalizeStyle({ left: $setup.shown.x + 'px', top: $setup.shown.y + 'px' })
        }, [
          ($setup.shown.result === 'hit' && !$setup.pixelAnswer)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : _createCommentVNode("v-if", true),
          ($setup.shown.result === 'hit' && !$setup.pixelAnswer)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.sparks, (s, i) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: i,
                  class: "nge-gemfx-spark",
                  style: _normalizeStyle({ '--a': s.a + 'deg', '--d': s.d + 'px' })
                }, null, 4 /* STYLE */))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          ($setup.shown.result === 'already')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("v-if", true),
          (_openBlock(), _createElementBlock("svg", _hoisted_6, [
            _hoisted_7,
            ($setup.shown.result === 'miss')
              ? (_openBlock(), _createElementBlock("path", _hoisted_8))
              : _createCommentVNode("v-if", true)
          ])),
          _createElementVNode("span", _hoisted_9, [
            _createTextVNode(_toDisplayString($setup.shown.head), 1 /* TEXT */),
            ($setup.shown.sub)
              ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString($setup.shown.sub), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ], 6 /* CLASS, STYLE */))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}